module.exports = __webpack_public_path__ + "img/img-ballade.db7691e0.png";